module.exports = __webpack_public_path__ + "img/sword-laser.97660932.svg";